import { TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';
import { ConditionOperators } from 'src/common/types/graphql.generated';

import { BusinessUnitsTableDataQueryVariables } from '../BusinessUnitsTable.generated';

interface IBusinessUnitsTableParams {
	days: number;
	filters?: IFilterOptions;
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard;
}

export const buildBusinessUnitsTableVariables = ({
	days,
	filters,
	labelsExcludedFromDashboard
}: IBusinessUnitsTableParams): BusinessUnitsTableDataQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<BusinessUnitsTableDataQueryVariables>();

	if (filters) {
		const dynamicFilterOptions: TFilterOptions = omit(filters, ['dateRange', 'searchValue']);

		variablesBuilder.addTupleFilterParam(
			CUSTOM_FIELDS_FILTER_PARAM_KEY,
			dynamicFilterOptions,
			ConditionOperators.All
		);
	}

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof BusinessUnitsTableDataQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const variables = variablesBuilder.getVariables();

	return {
		...variables,
		days
	};
};
